import { type EntityContainerProps } from "@client/viewer/layout/Entity/Container/container";
import classNames from "classnames";
import * as React from "react";
import OverPopup from "./Over/container";
import PushPopup from "./Push/container";

export interface PopupContainerProps {
  activePopupId?: string;
  behaviour?: "over" | "push";
  canClose: boolean;
  children?: any;
  className?: string;
  EntityContainer?: React.ComponentType<EntityContainerProps>;
  keepOpenOnOverlayClick?: boolean;
  isEditMode: boolean;
  popupClassName?: string;
  pushPosition?: "bottom" | "top";
  style: React.CSSProperties;
  topMenu?: any;
}

export default (props: PopupContainerProps) => (
  <div
    id="wsc_popup_container"
    className={classNames(props.className, { active: props.activePopupId && props.isEditMode })}
    style={props.style}
  >
    {props.activePopupId && props.behaviour === "over" && (
      <OverPopup
        canClose={props.canClose}
        className={props.popupClassName}
        keepOpenOnOverlayClick={props.keepOpenOnOverlayClick}
        id={props.activePopupId}
        source="popup"
        topMenu={props.topMenu}
        EntityContainer={props.EntityContainer}
      />
    )}

    {props.activePopupId && props.behaviour === "push" && props.pushPosition === "top" && (
      <PushPopup
        canClose={props.canClose}
        className={props.popupClassName}
        id={props.activePopupId}
        source="popup"
        topMenu={props.topMenu}
        EntityContainer={props.EntityContainer}
      />
    )}

    {props.children}

    {props.activePopupId && props.behaviour === "push" && props.pushPosition === "bottom" && (
      <PushPopup
        canClose={props.canClose}
        className={props.popupClassName}
        id={props.activePopupId}
        source="popup"
        topMenu={props.topMenu}
        EntityContainer={props.EntityContainer}
      />
    )}
  </div>
);
